import React from 'react';
import PropTypes from 'prop-types';

import styles from './HpRespShopByModuleLocations.scss';
import { trackShopByLocationClick } from './helpers/ShopByTracking';

function HpRespShopByModuleLocations({ location }) {
    return (
        <div
            className={styles.locationWrapper}
            style={{ backgroundImage: `url(${location.imageUrl})` }}
        >
            <span className={styles.header}>{location.title}</span>

            <ul className={styles.locationsList}>
                {location.items.map((item, index) => (
                    <li
                        key={item.cmsId}
                        data-tn={`dealer-location-${item.title.toLowerCase().replace(' ', '-')}`}
                        className={styles.locationItem}
                    >
                        <a
                            href={item.link}
                            className={styles.locationLink}
                            onClick={() => trackShopByLocationClick(item, index)}
                        >
                            {item.title}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

HpRespShopByModuleLocations.propTypes = {
    location: PropTypes.shape({
        title: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                cmsId: PropTypes.number.isRequired,
                title: PropTypes.string.isRequired,
                link: PropTypes.string.isRequired,
            })
        ).isRequired,
    }).isRequired,
};

export { HpRespShopByModuleLocations };
